import {
  H_03,
  HERO_DEFAULTS,
  hideH03Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const H03_PLASMIC_PROPS = {
  h03Heading: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_03].heading,
    description: "Main hero heading (H03 only)",
    hidden: hideH03Props,
  },
  h03Description: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_03].description,
    description: "Hero description text (H03 only)",
    hidden: hideH03Props,
  },
  h03TeamTitle: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_03].teamTitle,
    description: "Team title (H03 only)",
    hidden: hideH03Props,
  },
  h03TeamDate: {
    type: "dateString",
    description: "Team date (H03 only)",
    hidden: hideH03Props,
  },
  h03TeamDateFormat: {
    type: "string",
    defaultValue: "Do MMM YYYY",
    description: "Date format for team date (H03 only)",
    hidden: hideH03Props,
  },
  h03BadgeLogo: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_03].badgeLogo,
    description: "Badge logo (H03 only)",
    hidden: hideH03Props,
  },
  h03BadgeLogoAlt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_03].badgeLogoAlt,
    description: "Badge logo alt text (H03 only)",
    hidden: hideH03Props,
  },
  h03HeroImage: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_03].heroImage,
    description: "Hero image (H03 only)",
    hidden: hideH03Props,
  },
  h03HeroImageAlt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_03].heroImageAlt,
    description: "Hero image alt text (H03 only)",
    hidden: hideH03Props,
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
